import React from 'react';
import './MenuItemCard.css';
import vegLogo from '../image/veg-logo.svg';
import nonVegLogo from '../image/non-veg.png';
import food from '../image/food-img.png';


export default function MenuItemCard({ item, image, isSelected, onToggle, isDisabled, hideCheckbox, isveg }) {

    return (
        <>
            {!item ?
                (<div className='menu-item-card-header'>Not available</div>)
                :
                (
                    <div className={`menu-item-card ${isSelected ? 'selected' : ''}`}>

                        <div className='menu-c-container'>
                            <div className='menu-c-left-container'>
                                {isveg ? (
                                    <div className="veg-logo">
                                        <img src={vegLogo} alt="veg-menu-item" />
                                    </div>
                                ) : (
                                    <div className="non-veg-logo">
                                        <img src={nonVegLogo} alt="non-veg-menu-item" />
                                    </div>
                                )}

                                <h1 className='menu-c-name'>{item}</h1>
                                <p className='menu-c-description'>
                                    {item.description} <span className='menu-c-span'>More</span>
                                </p>
                                {/* <span className='menu-c-span'>More</span> */}
                            </div>

                            <div className='menu-c-right-container'>
                                <div className={`menu-c-input ${isDisabled ? 'input-hide' : ''}`}>
                                    {!hideCheckbox && (
                                        <input
                                            type="checkbox"
                                            checked={isSelected}
                                            onChange={() => onToggle(item)}
                                            disabled={isDisabled}
                                        />
                                    )}
                                </div>
                                <img src={image} alt="food" className='menu-c-img' />
                            </div>
                        </div>
                    </div>)}

        </>
    );
}
